
<div class="gallery-container">
  <div id="viewerSection" class="molstar-frozen">
    <!-- Molstar container -->
    <div id="myViewerCover"></div>
    <button (click)="previous()" class="arrow-left left"><img src="/assets/img/mobile/left-mat-btn.svg" alt="arrow-left" width="32" height="33"/></button>
    <div id="myViewer"></div>
    <button (click)="next()" class="arrow-right right"><img src="/assets/img/mobile/right-mat-btn.svg" alt="arrow-left" width="32" height="33"/></button>
  </div>

  <div class="gallery-nav">
    <div class="dot-indicators">
      @for (view of views; track view; let i = $index) {
        <span
          [class.active]="i === currentIndex"
          (click)="setView(i)"
        ></span>
      }
    </div>
  </div>

</div>
